import { Form, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const DeleteModal = ({ show, hide, onOk, title, subtitle }) => {
  return (
    <Modal
      width={500}
      open={show}
      onOk={() => {
        if (onOk) onOk();
        hide();
      }}
      onCancel={hide}
      centered
      className="tab_modal deleteWarningModal"

    >
      <Form layout="vertical" >
        <div style={{ margin: "auto", width: 100, fontSize: 80, color: "red" , lineHeight: "normal" , textAlign:"center" , marginBottom:"10px" }}><ExclamationCircleOutlined /></div>
        <h4 className="modal_title_cls mb-2">{title}</h4>
        <h4 className="modal_sub_title_cls mb-2">{subtitle}</h4>
      </Form>
    </Modal>
  );
};

export default DeleteModal;
